<template>
  <div class="page__chart">

    <chart-bar v-if="chartType === 'bar'"
               :mergedOptions="mergedOptions"
               :mergedData="mergedData">
    </chart-bar>

    <chart-doughnut v-if="chartType === 'doughnut'"
               :mergedOptions="mergedOptions"
               :mergedData="mergedData"
    />

    <chart-line v-if="chartType === 'line'"
                :mergedOptions="mergedOptions"
                :mergedData="mergedData">
    </chart-line>

    <chart-pie v-if="chartType === 'pie'"
                :mergedOptions="mergedOptions"
                :mergedData="mergedData">
    </chart-pie>

  </div>
</template>

<script>
  import ChartBar from './ChartBar'
  import ChartDoughnut from '@/components/Charts/ChartDoughnut'
  import ChartLine from './ChartLine'
  import ChartPie from '@/components/Charts/ChartPie'

  export default {
    name: 'Chart',
    components: {
      ChartBar,
      ChartDoughnut,
      ChartLine,
      ChartPie
    },
    props: {
      content:{
        type: Object,
        required: true
      }
    },
    data() {
      return {
        defaultOptions: {
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              }
            }]
          }
        },
      }
    },
    computed: {
      chartType () {
        if (this.content.chartType) {
          return this.content.chartType
        } else {
          return ""
        }
      },
      mergedData() {
        if (this.content.data.labels === "default") {
          // Merge global default data and page data.
          return {
            ...this.content.data,
            ...this.$store.state.globalData.defaults.data.defaultLabels
          }
        } else {
          return this.content.data
        }
      },
      mergedOptions () {
        let options = this.defaultOptions
        if (this.chartType === "doughnut" || this.chartType === "pie") {
          // Disable scales if doughnut or pie chart.
          options.scales = {}
        }
        if (this.content.options) {
          // Merge default options and page options.
          options = {
            ...this.defaultOptions,
            ...this.content.options
          }
        }
        return options
      }
    }
  }
</script>
